/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PresenceFieldEdit
 */
export interface PresenceFieldEdit {
  /**
   *
   * @type {string}
   * @memberof PresenceFieldEdit
   */
  field: string;
  /**
   *
   * @type {string}
   * @memberof PresenceFieldEdit
   */
  adminEmail: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof PresenceFieldEdit
   */
  editedAt: OffsetDateTime;
}

/**
 * Check if a given object implements the PresenceFieldEdit interface.
 */
export function instanceOfPresenceFieldEdit(
  value: object,
): value is PresenceFieldEdit {
  if (!("field" in value) || value["field"] === undefined) return false;
  if (!("adminEmail" in value) || value["adminEmail"] === undefined)
    return false;
  if (!("editedAt" in value) || value["editedAt"] === undefined) return false;
  return true;
}

export function PresenceFieldEditFromJSON(json: any): PresenceFieldEdit {
  return PresenceFieldEditFromJSONTyped(json, false);
}

export function PresenceFieldEditFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PresenceFieldEdit {
  if (json == null) {
    return json;
  }
  return {
    field: json["field"],
    adminEmail: json["adminEmail"],
    editedAt: json["editedAt"],
  };
}

export function PresenceFieldEditToJSON(json: any): PresenceFieldEdit {
  return PresenceFieldEditToJSONTyped(json, false);
}

export function PresenceFieldEditToJSONTyped(
  value?: PresenceFieldEdit | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    field: value["field"],
    adminEmail: value["adminEmail"],
    editedAt: value["editedAt"],
  };
}
